import { render, staticRenderFns } from "./MusicSidebar.vue?vue&type=template&id=125f6f5a"
import script from "./MusicSidebar.vue?vue&type=script&lang=js"
export * from "./MusicSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125f6f5a')) {
      api.createRecord('125f6f5a', component.options)
    } else {
      api.reload('125f6f5a', component.options)
    }
    module.hot.accept("./MusicSidebar.vue?vue&type=template&id=125f6f5a", function () {
      api.rerender('125f6f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/MusicSidebar.vue"
export default component.exports